import { useEffect, useState } from "react";
import { Wheat, Menu as MenuIcon, X } from "lucide-react";
import { Button } from "../components/ui/button";
import { CONTACT } from "../data/content";

const LINKS = [
  { label: "Menu", href: "#menu" },
  { label: "About", href: "#about" },
  { label: "Custom Order", href: "#custom-order" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 h-20 transition-all duration-300 ${
        scrolled ? "bg-cream/90 backdrop-blur-md border-b border-[#E8E2D9] shadow-[0_4px_20px_-12px_rgba(45,40,37,0.25)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
        <button data-testid="logo-home" onClick={() => go("#hero")} className="flex items-center gap-3 group">
          <span className="grid place-items-center w-11 h-11 rounded-full bg-olive text-cream group-hover:bg-olive-hover transition-colors">
            <Wheat size={22} strokeWidth={2} />
          </span>
          <span className="text-left leading-none">
            <span className="block font-serif text-lg text-ink tracking-tight">Healthy Home Bakery</span>
            <span className="block text-[10px] uppercase tracking-[0.25em] text-olive font-semibold mt-1">{CONTACT.tagline}</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-ink/80 hover:text-terracotta transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-terracotta hover:after:w-full after:transition-all"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <span className="text-xs font-semibold px-3 py-1.5 rounded-full bg-[#F3F7F1] text-[#3E5334] border border-[#E1EADD]">
            100% Zero Sugar
          </span>
          <Button
            data-testid="nav-order-cta"
            onClick={() => go("#menu")}
            className="rounded-full bg-terracotta hover:bg-terracotta-hover text-white px-6 h-11"
          >
            Order Baked Goods
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden grid place-items-center w-11 h-11 rounded-full bg-white/70 border border-[#E8E2D9] text-ink"
        >
          {open ? <X size={20} /> : <MenuIcon size={20} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-cream border-b border-[#E8E2D9] px-6 py-5 space-y-1 reveal">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(" ", "-")}`}
              onClick={() => go(l.href)}
              className="block w-full text-left py-3 text-ink font-medium border-b border-[#EFE9E0] last:border-0"
            >
              {l.label}
            </button>
          ))}
          <Button
            data-testid="mobile-order-cta"
            onClick={() => go("#menu")}
            className="mt-4 w-full rounded-full bg-terracotta hover:bg-terracotta-hover text-white h-12"
          >
            Order Baked Goods
          </Button>
        </div>
      )}
    </header>
  );
};
